<div class="modal" tabindex="-1" role="dialog" >
  Logs - {{this.jobData}}
</div>